import { Film, LogOut, Plus } from 'lucide-react';
import { APP_VERSION } from '@logica/shared';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Brand } from '../components/Brand';
import { useAuth } from '../hooks/useAuth';

export function AdminLayout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="admin-shell">
      <aside className="sidebar">
        <Brand />
        <nav aria-label="Administrator navigation">
          <NavLink to="/manage/videos" end><Film size={18} />Video library</NavLink>
          <NavLink to="/manage/videos/create"><Plus size={18} />Upload video</NavLink>
        </nav>
        <div className="sidebar__account">
          <div className="avatar" aria-hidden="true">{admin?.name.charAt(0).toUpperCase()}</div>
          <div><strong>{admin?.name}</strong><span>{admin?.email}</span><small>v{APP_VERSION}</small></div>
          <button className="icon-button" title="Sign out" onClick={() => void logout().then(() => navigate('/manage/login'))}><LogOut size={18} /></button>
        </div>
      </aside>
      <main className="admin-main"><Outlet /></main>
    </div>
  );
}
